export default function textsAnimations(
  buttonRef,
  titleRef,
  textContentArray,
  animStartDelay,
  textsAnimDelay,
  separatorRef,
  durationAnimations,
  numberOfTexts,
  textTl
) {
  // if there is button and not the sections "services"
  if (buttonRef.current) {
    textTl
      .from(titleRef.current, {
        delay: animStartDelay,
        y: 20,
        opacity: 0,
      })
      .from(
        textContentArray,
        {
          stagger: 0.3,
          y: 20,
          opacity: 0,
        },
        `-=${textsAnimDelay}`
      )
      .from(buttonRef.current, {
        y: 20,
        opacity: 0,
      });
  }

  // if there is no button, no separator and not the sections "services"
  if (!buttonRef.current && !separatorRef.current) {
    textTl
      .from(titleRef.current, {
        delay: animStartDelay,
        y: 20,
        opacity: 0,
      })
      .from(
        textContentArray,
        {
          stagger: 0.3,
          y: 20,
          opacity: 0,
        },
        `-=${textsAnimDelay}`
      );
  }

  // if there is no button, with separator and not the sections "services"
  if (!buttonRef.current && separatorRef.current) {
    const separatorStartingTime = `-=${
      durationAnimations * numberOfTexts + 0.1
    }`;

    textTl
      .from(titleRef.current, {
        delay: animStartDelay,
        y: 20,
        opacity: 0,
      })
      .from(
        textContentArray,
        {
          stagger: 0.3,
          y: 20,
          opacity: 0,
        },
        `-=${textsAnimDelay}`
      )
      .from(
        separatorRef.current,
        {
          scaleX: 0,
          transformOrigin: "left",
        },
        separatorStartingTime
      );
  }
}
